import * as React from 'react';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { makeStyles } from 'tss-react/mui';

/**
Lägger till en caption
*/

const useStyles = makeStyles()({
  headerContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    flex: 1,
  },
  leftPadding: {
    paddingLeft: 8,
  },
  headerContainerWithMenu: {
    paddingBottom: 4,
  },
  menuContainer: {
    display: 'flex',
    position: 'relative',
    top: -12,
  },
} as const);

interface ICaptionContext {
  menuRef: React.RefObject<HTMLDivElement | null> | null;
  legendRef: React.RefObject<HTMLDivElement | null> | null;
}

export const CaptionContext = React.createContext<ICaptionContext>({
  menuRef: null,
  legendRef: null,
});

const addCaption =
  (caption: string, leftPadding?: boolean) =>
  <T extends {}>(
    WrappedComp: React.ComponentType<React.PropsWithChildren<T>>
  ): React.ComponentType<React.PropsWithChildren<T>> =>
  props => {
    const { classes, cx } = useStyles();
    const legendRef = React.useRef<HTMLDivElement | null>(null);
    const menuRef = React.useRef<HTMLDivElement | null>(null);
    return (
      <CaptionContext.Provider
        value={{ menuRef: menuRef, legendRef: legendRef }}
      >
        {caption && (
          <div
            className={cx(classes.headerContainer, {
              [classes.headerContainerWithMenu]: menuRef.current !== null,
              [classes.leftPadding]: leftPadding,
            })}
          >
            <EDTypography variant="overline" color="textSecondary" bold>
              {caption}
            </EDTypography>
            <div className={classes.menuContainer}>
              <div ref={legendRef} />
              <div ref={menuRef} />
            </div>
          </div>
        )}
        <WrappedComp {...props} />
      </CaptionContext.Provider>
    );
  };

export default addCaption;
